module.exports = __webpack_public_path__ + "static/media/Avenir.49fd56eb.ttc";